import React, { useState, createContext, useEffect } from 'react'
import { Surface } from '@americanexpress/dls-react'

// import { Header } from './Header'
import styles from './scss/Layout.module.scss'

export const DlsModeContext = createContext()
export const Layout = ({ children }) => {
  const [dlsMode, setDlsMode] = useState('dark') // optons are `light`, `dark`, or `system`

  useEffect(() => {
    const storedDlsMode = localStorage.getItem('dlsMode')
    if (storedDlsMode) {
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setDlsMode(storedDlsMode)
    }
  }, [])

  return (
    <Surface
      variant='base'
      data-dls-mode={dlsMode}
      className={`header text-align-center ${styles.wrapper}`}
    >
      <div className={styles.wrapper}>
        {/* <Header dlsMode={dlsMode} setDlsMode={setDlsMode} /> */}
        <div className={`container ${styles.container}`}>
          <div className='childWrapper'>
            <DlsModeContext.Provider value={dlsMode}>{children}</DlsModeContext.Provider>
          </div>
        </div>
      </div>
    </Surface>
  )
}
